import { render } from "./ticket.vue?vue&type=template&id=20fc8632"
import script from "./ticket.vue?vue&type=script&lang=ts"
export * from "./ticket.vue?vue&type=script&lang=ts"
script.render = render

export default script